<!-- <div class="dialog delete" *ngIf="userstage === 'MCTConfirmation'">
  <div mat-dialog-title class="dialogHeader">
  </div>
  <mat-divider></mat-divider>
  <div mat-dialog-content class="content">
    <div><strong>Are you an existing MCT?</strong></div>
  </div>
  <mat-divider></mat-divider>
  <div mat-dialog-actions class="footer">
    <button mat-flat-button class="flat-button" (click)="yesClicked()">Yes</button>
    <button mat-flat-button class="flat-button" (click)="noClicked()">No</button>
  </div>
  <div class="footer-note">
    <span class="note">
      Note: If you are an Active MCT, please use your MCT email to access the portal. 
      If you are unaware of your MCT email, please contact Pearson Support at <a aria-label="Email MCT Support at mctpvsupport@pearson.com" href="mailto:mctpvsupport@pearson.com">mctpvsupport&#64;pearson.com</a>.
    </span>
  </div>
</div> -->


  <div class="dialog delete" *ngIf="userstage === 'newMCTUser'">
  <div mat-dialog-title class="dialogHeader">
  </div>
  <mat-divider></mat-divider>
  <div mat-dialog-content class="content">
    <div><strong>Please read carefully before proceeding:</strong></div>
    <div>
        <span>Your email address does not appear to be associated with an MCT Profile.</span>
        <ul class="list-container">
            <li>If you are a new MCT, please select Continue to initiate the registration process.</li>
            <li>If you are an Active MCT, please sign in using the email associated with your MCT Account. If you are unable to sign in using your MCT email, please contact Pearson Support at <a aria-label="Email MCT Support at mctpvsupport@pearson.com" href="mailto:mctpvsupport@pearson.com">mctpvsupport&#64;pearson.com</a>.</li>
        </ul>
    </div>
  </div>
  <mat-divider></mat-divider>
  <div mat-dialog-actions class="footer">
    <button mat-flat-button class="flat-button" (click)="continueClicked()">Continue</button>
    <button mat-flat-button class="flat-button" (click)="cancelClicked()">Cancel</button>
  </div>
</div>



<div class="dialog delete" *ngIf="userstage === 'FTE_USER'">
  <div mat-dialog-title class="dialogHeader">
  </div>
  <mat-divider></mat-divider>
  <div mat-dialog-content class="content">
    <div>
        <span>
          If you are a Microsoft FTE, please reach out to the MCT Program Team for instructions on how to enrol 
          in the MCT Program at 
          <a aria-label="Email MCT Program at mctprog@microsoft.com" href="mailto:mctprog@microsoft.com">
            mctprog&#64;microsoft.com
          </a>. 
        </span>
    </div>
  </div>
  <mat-divider></mat-divider>
  <div mat-dialog-actions class="footer">
    <button mat-flat-button class="flat-button" (click)="FTEAction()">OK</button>
  </div>
</div>



<div class="dialog delete" *ngIf="userstage === 'ISCPCertificationModalConfimation'">
  <div mat-dialog-title class="dialogHeader">
  </div>
  <mat-divider></mat-divider>
  <div mat-dialog-content class="content">
    <div><strong>ISCP Certification Confirmation:</strong></div>
    <div>
        <span>Do you have an ISCP Certification OR an EETS Certificate OR an OBE Certificate from the Microsoft Garage?</span>
    </div>
  </div>
  <mat-divider></mat-divider>
  <div mat-dialog-actions class="footer">
    <button mat-flat-button class="flat-button" (click)="ISCPYesClicked()">YES</button>
    <button mat-flat-button class="flat-button" (click)="ISCPNoClicked()">NO</button>
  </div>
</div>